<template>
  <page>
    <div>
      <v-card>
        <form>
          <message :messages="messages"></message>
          <v-expansion-panels v-model="panel1" multiple>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div>
                <v-icon>mdi-filter-variant</v-icon> Select by
              </div>
            </v-expansion-panel-header>
              <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex xs5>
                        <v-radio-group v-model="form.periodType" :mandatory="true" @change="doPeriodType($event)">
                          <v-radio :label="label.perEndDate" value="perEndDate"></v-radio>
                          <v-radio :label="label.acctPeriod" value="acctPeriod"></v-radio>
                        </v-radio-group>
                      </v-flex>
                      <v-flex xs7>
                        <v-flex xs12>
                          <cal-picker v-model="form.perEndDate" :label="label.perEndDate" :data-vv-as="form.perEndDate" data-vv-name="perEndDate"
                            :disabled="disablePerEndDate" :max="new Date()" @change="getAcctPer(form.perEndDate)"></cal-picker>
                        </v-flex>
                        <v-flex xs12>
                          <v-autocomplete :items="acctPeriodList" v-model="form.acctPeriod" :label="label.acctPeriod" item-text="label" item-value="value"
                            data-vv-name="acctPeriod" :data-vv-as="label.acctPeriod" :error-messages="errors.collect('acctPeriod')" v-validate="'required'"
                            :disabled="disableAcctPeriod" @change="validateAcctPeriod"></v-autocomplete>
                        </v-flex>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs6>
                        <v-autocomplete :items="sortByList" v-model="form.sortBy" :label="label.sortBy" item-text="label" item-value="value"
                          data-vv-name="sortBy" :data-vv-as="label.sortBy" :error-messages="errors.collect('sortBy')" v-validate="'required'">
                        </v-autocomplete>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
          </v-expansion-panels>
          <v-divider></v-divider>
          <v-expansion-panels v-model="panel2" multiple>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div>
                <v-icon>mdi-filter-variant</v-icon> Selection Criteria
              </div>
            </v-expansion-panel-header>
              <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-sm>
                    <v-layout row wrap>
                      <v-flex xs6>
                        <v-text-field v-model="form.acctNoFrom" :label="label.acctNoFrom" :error-messages="errors.collect('acctNoFrom')"
                          :data-vv-as="label.acctNoFrom" data-vv-name="acctNoFrom" append-icon="mdi-magnify" @click:append="getHelpList('acctNoFrom')"
                          readonly clearable v-validate="acctNoValidate('accNoFrom')">
                        </v-text-field>
                      </v-flex>
                      <v-flex xs6>
                        <v-text-field v-model="form.acctNoTo" :label="label.acctNoTo" :error-messages="errors.collect('acctNoTo')"
                          :data-vv-as="label.acctNoTo" data-vv-name="acctNoTo" append-icon="mdi-magnify" @click:append="getHelpList('acctNoTo')"
                          readonly v-validate="acctNoValidate('acctNoTo')"
                          :disabled="acctNoToDisc">
                        </v-text-field>
                      </v-flex>
                      <v-flex xs6>
                        <v-text-field v-model="form.fund" :label="label.fund" :error-messages="errors.collect('fund')"
                          :data-vv-as="label.fund" data-vv-name="fund" append-icon="mdi-magnify" @click:append="getHelpList('fund')" readonly>
                        </v-text-field>
                      </v-flex>
                      <v-flex xs6>
                        <v-text-field v-model="form.acctNoSfx" :label="label.acctNoSfx" :error-messages="errors.collect('acctNoSfx')"
                          :data-vv-as="label.acctNoSfx" data-vv-name="acctNoSfx" append-icon="mdi-magnify" @click:append="getHelpList('acctNoSfx')" readonly>
                        </v-text-field>
                      </v-flex>
                      <v-flex xs6>
                        <v-text-field v-model="form.branch" :label="label.branch" :error-messages="errors.collect('branch')"
                          :data-vv-as="label.branch" data-vv-name="branch" append-icon="mdi-magnify" @click:append="getHelpList('branch')" readonly>
                        </v-text-field>
                      </v-flex>
                    </v-layout>
                     <v-layout row wrap>
                      <v-flex xs12>
                        <v-checkbox
                          v-model="form.prtRptRunTime"
                          :label="label.prtRptRunTime"
                          data-vv-name="prtRptRunTime"
                          :data-vv-as="label.prtRptRunTime"
                        />
                      </v-flex>
                      <v-flex xs12 class="pt-3">
                        <v-btn class="mr-2" color="info" :loading="submitting" @click.prevent="doSchedule">
                          <v-icon left dark>mdi-clock</v-icon>
                          {{label.schedule}}
                        </v-btn>
                        <v-btn class="mr-2" color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
                          <v-icon left dark>mdi-file-export</v-icon>
                          {{label.export}}
                        </v-btn>
                        <v-btn-toggle dense mandatory v-model="form.format">
                          <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
                            <span>{{format.label}}</span>
                            <v-icon :color="format.color">{{format.icon}}</v-icon>
                          </v-btn>
                        </v-btn-toggle>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-card>
    </div>

    <v-dialog v-model="interList" width="900px" persistent>
      <intermediary-help-list
        perDebtTran="true"
        interGrps="10,11,20,25"
        @close="doClose" @assign-intermediary="doAssign($event)"></intermediary-help-list>
    </v-dialog>

    <v-dialog v-model="fundList" width="900px" persistent>
      <multi-fund-help-list :fnd="form.fund" @close="doClose" @doAssign="doAssignMulti($event)"></multi-fund-help-list>
    </v-dialog>

    <v-dialog v-model="acctNoSfxList" width="900px" persistent>
      <multi-acct-no-sfx-help-list :acctNoSfx="form.acctNoSfx" @close="doClose" @doAssign="doAssignMulti($event)"></multi-acct-no-sfx-help-list>
    </v-dialog>

    <v-dialog v-model="branchList" width="900px" persistent>
      <multi-home-branch-help-list :brn="form.branch" @close="doClose" @doAssign="doAssignMulti($event)"></multi-home-branch-help-list>
    </v-dialog>

    <v-dialog v-model="scheduleJobModal" width="1000px"   persistent>
      <ScheduleJob @close="scheduleJobModal = false" :jobName="jobName" :jobDesc="jobDesc"></ScheduleJob>
    </v-dialog>

    <warning v-model="errdPerEnd" :info="true">
      {{ errdPerEndMsg }}
    </warning>

    <warning v-model="errAcctPeriod" :info="true">
      {{ errAcctPeriodMsg }}
    </warning>

    <warning v-model="errdPrevEndDate" :info="true">
      {{ errdPrevEndDateMsg }}
    </warning>

  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { reportFormat } from '@/const/report'
import { extractMenu } from '@/utils/extract'
import { expandURI } from '@/utils/ajax'
import { parseISO } from 'date-fns'
import ScheduleJob from '@/components/core/common/dialog/ScheduleJob'
import IntermediaryHelpList from '@/components/core/common/dialog/IntermediaryHelpList.vue'
import MultiFundHelpList from '@/components/core/common/dialog/MultiFundHelpList.vue'
import MultiAcctNoSfxHelpList from '@/components/core/common/dialog/MultiAcctNoSfxHelpList.vue'
import MultiHomeBranchHelpList from '@/components/core/common/dialog/MultiHomeBranchHelpList.vue'

export default {
  data() {
    return {
      label: {
        perEndDate: 'Period End Date',
        acctPeriod: 'Account Month/Year',
        sortBy: 'Sort By',
        acctNoFrom: 'From Account No.',
        acctNoTo: 'To',
        fund: 'Fund',
        acctNoSfx: 'Account No. Suffix',
        branch: 'Home Branch',
        export: 'Export To',
        format: 'Export Format',
        schedule: 'Schedule',
        prtRptRunTime: 'Print Run-time Parameters'
      },
      form: {
        periodType: 'perEndDate',
        perEndDate: new Date(),
        acctPeriod: '',
        iAcctYr: 0,
        iAcctMth: 0,
        dPerEnd: new Date(),
        dPrevEndDate: '',
        sortBy: 'C',
        acctNoFrom: '',
        acctNoTo: '',
        fund: 'All',
        acctNoSfx: 'All',
        branch: 'All',
        prtRptRunTime: true
      },
      supportedFormat: [],
      submitting: false,
      menu: {},
      mode: '',
      toggleFilters: [true],
      acctPeriodList: [],
      sortByList: [
        { label: 'Commencement Date', value: 'C' },
        { label: 'Transaction Date', value: 'T' }
      ],
      disablePerEndDate: false,
      disableAcctPeriod: true,
      interList: false,
      fundList: false,
      acctNoSfxList: false,
      branchList: false,
      acctNoToDisc: true,
      errdPerEnd: false,
      errAcctPeriod: false,
      errdPrevEndDate: false,
      errdPerEndMsg: '',
      errAcctPeriodMsg: '',
      errdPrevEndDateMsg: '',
      scheduleJobModal: false,
      jobName: 'qrtzSOASupplement',
      jobDesc: 'Statement of Account Supplement',
      panel1: [0],
      panel2: [0]
    }
  },
  methods: {
    async doInit() {
      try {
        if (this.$store.state.reports.accountReports.init !== 1) {
          await this.$store.dispatch('accountReportsInit')
        }
        const apiURI = this.rptMenu.soaSupplement
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.menu = extractMenu(result.data._links)
            this.getAcctPeriod()
          }
        }
        if (this.form.periodType === 'perEndDate') {
          this.getAcctPer(this.form.perEndDate)
        } else {
          this.validateAcctPeriod()
        }
      } catch (err) {
        throw err
      }
    },
    async getAcctPeriod() {
      const apiURI = this.menu.acctPeriodList
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const data = result.data.data
          this.acctPeriodList = []
          if (data) {
            for (let i in data) {
              this.acctPeriodList.push({ value: data[i].value, label: data[i].label })
            }
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doPeriodType(val) {
      switch (val) {
        case 'perEndDate':
          this.disablePerEndDate = false
          this.disableAcctPeriod = true
          this.form.perEndDate = new Date()
          this.form.acctPeriod = ''
          break
        case 'acctPeriod':
          this.disablePerEndDate = true
          this.disableAcctPeriod = false
          this.form.perEndDate = ''
          break
        default:
          this.disablePerEndDate = false
          this.disableAcctPeriod = true
      }
    },
    async getAcctPer(date) {
      const apiURI = this.menu.getAcctPer
      if (apiURI) {
        this.loading = true
        try {
          const expand = { modNo: 3, perEndDate: date }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            if (data.errMsg === '0' || data.errMsg === '' ||
              data.errMsg === undefined) {
              this.form.iAcctMth = parseInt(data.acctMth)
              this.form.iAcctYr = parseInt(data.acctYr)
              this.form.dPerEnd = expand.perEndDate
              if (this.form.periodType === 'acctPeriod') {
                this.form.acctPeriod = data.acctMth + '/' + data.acctYr
              } else {
                this.form.acctPeriod = ''
              }
              this.getPrevEndDate()
            } else {
              this.errdPerEnd = true
              this.errdPerEndMsg = data.errMsg
              this.$toast.error(data.errMsg)
            }
            this.errdPerEnd = false
            this.errdPerEndMsg = ''
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async validateAcctPeriod() {
      const perMthYr = this.form.acctPeriod.split('/')
      const cAcctMth = parseInt(perMthYr[0])
      const cAcctYr = parseInt(perMthYr[1])
      const apiURI = this.menu.validateAcctPeriod
      const today = parseISO(new Date())
      if (apiURI) {
        this.loading = true
        try {
          const expand = { acctPerMth: cAcctMth, acctPerYr: cAcctYr }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            const acctPerEndDate = parseISO(data.acctPerEndDate)
            if (data.acctPerEndDate !== null) {
              if (today < acctPerEndDate) {
                this.$toast.error('Accounting Period must be current or less')
              } else {
                this.form.iAcctMth = cAcctMth
                this.form.iAcctYr = cAcctYr
                this.form.dPerEnd = data.acctPerEndDate
              }
              this.getPrevEndDate()
            } else {
              this.errAcctPeriod = true
              this.errAcctPeriodMsg = 'This is not a valid Accounting Period'
              this.$toast.error(this.errAcctPeriodMsg)
            }
            this.errAcctPeriod = false
            this.errAcctPeriodMsg = ''
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async getPrevEndDate() {
      const perMthYr = this.form.acctPeriod.split('/')
      const cAcctMth = parseInt(perMthYr[0])
      const cAcctYr = parseInt(perMthYr[1])
      const apiURI = this.menu.validateAcctPeriod
      const today = parseISO(new Date())
      if (apiURI) {
        this.loading = true
        try {
          let acctPerMth = this.form.iAcctMth - 1
          let acctPerYr = this.form.iAcctYr - 1
          if (acctPerMth === 0) {
            acctPerMth = 12
          } else {
            acctPerYr = this.form.iAcctYr
          }
          const expand = { acctPerMth: acctPerMth, acctPerYr: acctPerYr }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            const acctPerEndDate = parseISO(data.acctPerEndDate)
            if (data.acctPerEndDate !== null) {
              if (today < acctPerEndDate) {
                this.$toast.error('Accounting Period must be current or less')
              } else {
                this.form.iAcctMth = cAcctMth
                this.form.iAcctYr = cAcctYr
              }
              this.form.dPrevEndDate = data.acctPerEndDate
            } else {
              this.errdPrevEndDate = true
              this.errdPrevEndDateMsg = 'This is not a valid Accounting Period'
              this.$toast.error(this.errdPrevEndDateMsg)
            }
            this.errdPrevEndDate = false
            this.errdPrevEndDateMsg = ''
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    scheduleJob() {
      this.scheduleJobModal = true
    },
    getHelpList(fieldName) {
      this.mode = fieldName
      switch (fieldName) {
        case 'acctNoFrom':
        case 'acctNoTo':
          this.interList = true
          break
        case 'fund':
          this.fundList = true
          break
        case 'acctNoSfx':
          this.acctNoSfxList = true
          break
        case 'branch':
          this.branchList = true
          break
      }
    },
    async doAssign(data) {
      switch (this.mode) {
        case 'acctNoFrom':
          this.form.acctNoFrom = data
          break
        case 'acctNoTo':
          this.form.acctNoTo = data
          break
      }
    },
    async doAssignMulti(Obj) {
      switch (this.mode) {
        case 'fund':
          this.form.fund = []
          this.form.fund = Obj.finalSelectedItems.toString()
          break
        case 'acctNoSfx':
          this.form.acctNoSfx = []
          this.form.acctNoSfx = Obj.finalSelectedItems.toString()
          break
        case 'branch':
          this.form.branch = []
          this.form.branch = Obj.finalSelectedItems.toString()
          break
      }
    },
    doClose() {
      this.interList = false
      this.fundList = false
      this.acctNoSfxList = false
      this.branchList = false
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          let validPass = true
          if (this.errdPerEndMsg !== '') {
            this.errdPerEnd = true
            validPass = false
          }
          if (this.errAcctPeriodMsg !== '') {
            this.errAcctPeriod = true
            validPass = false
          }
          if (this.errdPrevEndDateMsg !== '') {
            this.errdPrevEndDate = true
            validPass = false
          }
          if (validPass) {
            this.processExport()
          }
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.exportSOASupp
      if (apiURI) {
        try {
          this.submitting = true
          await this.$http.post(apiURI, this.form)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doSchedule() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          let validPass = true
          if (this.errdPerEndMsg !== '') {
            this.errdPerEnd = true
            validPass = false
          }
          if (this.errAcctPeriodMsg !== '') {
            this.errAcctPeriod = true
            validPass = false
          }
          if (this.errdPrevEndDateMsg !== '') {
            this.errdPrevEndDate = true
            validPass = false
          }
          if (validPass) {
            this.scheduleJob()
          }
        }
      })
    },
    acctNoValidate(fieldName) {
      if (fieldName === 'acctNoFrom') {
        return 'acctNoRangeFrom:' + this.form.acctNoTo
      } else {
        return 'acctNoRangeTo:' + this.form.acctNoFrom
      }
    }
  },
  created() {
    this.doInit()

    this.$validator.extend('acctNoRangeFrom', {
      getMessage(field, args) {
        return field + ' must less than or equal To Account No.'
      },
      validate(value, args) {
        if (value < args) {
          return false
        } else {
          return true
        }
      }
    })

    this.$validator.extend('acctNoRangeTo', {
      getMessage(field, args) {
        return field + ' must greater than or equal From Account No.'
      },
      validate(value, args) {
        if (value < args) {
          return false
        } else {
          return true
        }
      }
    })
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.accountReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    },
    acctMonthFromValidation() {
      if (this.form.acctMonthFrom !== '') {
        let validation = 'entry|numeric|max:2|mask_max_value:13|mask_min_value:1'
        if (this.form.reportType !== 'Master') {
          validation = validation + '|acctMthFrom:' + this.form.acctMonthTo
        }
        return validation
      } else {
        return ''
      }
    },
    acctMonthToValidation() {
      if (this.form.acctMonthTo !== '') {
        return 'entry|numeric|max:2|mask_max_value:13|mask_min_value:1|acctMthTo:' + this.form.acctMonthFrom
      } else {
        return ''
      }
    }
  },
  watch: {
    'supportedList': function (value) {
      if (value && value.length > 0) {
        // Default the 1st value
        this.form.format = value[0].value
      }
    },
    'form.acctNoFrom': function (value) {
      if (value !== undefined && value !== '' && value !== null) {
        this.acctNoToDisc = false
      } else {
        this.acctNoToDisc = true
        this.form.acctNoFrom = ''
        this.form.acctNoTo = ''
      }
    },
    'form.periodType': function (value) {
      if (value === 'acctPeriod') {
        let today = new Date()
        this.getAcctPer(today)
      }
    }
  },
  mixins: [
    MessageMixin
  ],
  components: {
    IntermediaryHelpList,
    MultiFundHelpList,
    MultiAcctNoSfxHelpList,
    MultiHomeBranchHelpList,
    ScheduleJob
  }
}

</script>
